module.exports = __webpack_public_path__ + "img/ElevatorOutlined.e54cc5a9.svg";